/**
 * Non-user-facing chart keys and styling literals for ForecastCard (Recharts data keys / visibility toggles).
 */

export const FORECAST_LINE_VISIBILITY = {
  estimates: 'estimates',
  reported: 'reported',
  previousYear: 'previousYear',
} as const;

export type ForecastLineVisibilityKey =
  (typeof FORECAST_LINE_VISIBILITY)[keyof typeof FORECAST_LINE_VISIBILITY];

/** Fallback stroke when theme grey token is missing */
export const PREVIOUS_YEAR_PREDICTION_GRAY = '#6B7280';

/** Dashed stroke pattern for previous-year series */
export const PREVIOUS_YEAR_STROKE_DASH = '5 5';
